export function fixNavLinkWidths() {
  const links = Array.from(document.querySelectorAll('.header__nav-link'));
  if (!links.length) return;
  const desktop = window.innerWidth >= 768;
  if (!desktop) {
    links.forEach(l => {
      l.style.width = '';
    });
    return;
  }
  const probe = document.createElement('span');
  probe.style.cssText = 'position:absolute;left:-9999px;top:0;visibility:hidden;white-space:nowrap;';
  document.body.appendChild(probe);
  links.forEach(link => {
    const cs = getComputedStyle(link);
    probe.style.fontFamily = cs.fontFamily;
    probe.style.fontSize = cs.fontSize;
    probe.style.fontWeight = '700';
    probe.style.fontStyle = cs.fontStyle;
    probe.style.lineHeight = cs.lineHeight;
    probe.textContent = link.textContent.trim();
    const w = probe.getBoundingClientRect().width;
    link.style.width = Math.ceil(w) + 'px';
  });
  probe.remove();
}
